module.exports = __webpack_public_path__ + "img/icon-analysis.26400281.svg";